import { GridRowsImage } from './GridRowsImage';

export const NoResultsOverlay = () => {
  return <GridRowsImage label="No Results Found by Your Query" />;
};
